<template>
    <div class="main-not-found">
        <p class="not-found-header">404</p>
        <p class="not-found-subheader">{{$t('text.page_not_found')}}</p>
    </div>
  </template>
  
<script>
  export default {
      name: "NotFoundPage",
  };

</script>

  <style>
  .main-not-found {
    height: 100%;
    background-color: #fff;
    padding-top: 200px;
    text-align: center;
  }
  .not-found-header {
    font-size: 100px;
    font-weight: bold;
  }

  .not-found-subheader {
    font-size: 40px;
  }
  </style>
  